import instanceQuery from '../../queries/sales/MaxoptraConfigurationQuery.graphql';
import defaultQuery from '../../queries/sales/MaxoptraConfigurationDefault.graphql';
import mutationQuery from '../../mutations/sales/MaxoptraConfigurationMutation.graphql';
import fragment from '../../fragments/sales/MaxoptraConfigurationFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const MaxoptraConfiguration: EntityType = {
  type: 'MaxoptraConfiguration',
  title: 'Maxoptra Configuration',
  formTitle: 'Maxoptra Configuration',
  formUrl: '/Sales/MaxoptraConfiguration',
  instance: instanceQuery,
  workspace: undefined,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'MAXOPTRA_CONFIGURATION',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default MaxoptraConfiguration;
